/** @jsxImportSource @emotion/react */
import React from 'react'
import { Link, LinkProps } from 'react-router-dom'

/**
 * This component is temporarily necessary (until `react-router-dom`: v6+) to properly handle
 * ref forwarding. This requirement was introduced by MUI v4 but react-router-dom is slightly behind.
 * For now, all Links passed to a MUI component must use this AdapterLink component.
 */
const AdapterLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (props, ref) => <Link innerRef={ref} {...props} />
)

AdapterLink.displayName = 'AdapterLink'

export default AdapterLink
